import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { dateFormat } from "../../util/DateUtil";

const useStyles = makeStyles({
  card: {
    margin: "auto",
    width: "100%",
    flexGrow: 1,
  },
});

const AlunoTurmaProfileViewV2 = ({ alunoTurma }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <Grid container spacing={3}>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Ano Letivo
            </Typography>
            <Typography variant="body1">
              {alunoTurma ? alunoTurma.turma.anoLetivo : ""}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Turma
            </Typography>
            <Typography variant="body1">
              {alunoTurma ? alunoTurma.turma.descricao : ""}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Nº Chamada
            </Typography>
            <Typography variant="body1">
              {alunoTurma ? alunoTurma.numeroChamada : ""}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Nome
            </Typography>
            <Typography variant="body1">
              {alunoTurma ? alunoTurma.aluno.nome : ""}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Data Entrada
            </Typography>
            <Typography variant="body1">
              {alunoTurma?.dataEntrada
                ? dateFormat(alunoTurma?.dataEntrada)
                : "--"}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Data Saída
            </Typography>
            <Typography variant="body1">
              {alunoTurma?.dataSaida ? dateFormat(alunoTurma?.dataSaida) : "--"}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AlunoTurmaProfileViewV2;
